<page-data-manager>
  <div class="ibox">
    <div class="ibox-title">
      <div class="ibox-tools">
        <button type="button"
                class="btn btn-primary"
                ng-disabled="ef.createNew"
                ng-click="ef.createNew = true"
                ng-if="$root.permissions.estadios_fenologicos.canManage">
          Novo
          <i class="fa fa-plus"></i>
        </button>
      </div>
      <h2>Estádios Fenológicos</h2>
    </div>
    <div class="ibox-content border-bottom m-b-sm">
      <!-- New item -->
      <edit-estadio-fenologico ng-show="ef.createNew"
                       atividades="ef.atividades">
      </edit-estadio-fenologico>

        <!-- Search box -->
        <form ng-submit="ef.filterItems()" class="row">
          <div class="col-xs-12">
            <h3>Filtrar</h3>
          </div>
          <div class="col-xs-4 form-group">
            <input type="search" name="descricao" id="descricao" ng-model="ef.filters.descricao" class="form-control" placeholder="Descrição">
          </div>
          <div class="col-xs-4 form-group">
            <ui-select name="filter-cultivar" id="filter-cultivar" ng-model="ef.filters.atividade">
              <ui-select-match>{{$select.selected.descricao}}</ui-select-match>
              <ui-select-choices repeat="atividade in ef.atividades | orderBy: 'descricao' | filter: $select.search">
                <span class="form-group" ng-bind-html="atividade.descricao | highlight: $select.search"></span>
              </ui-select-choices>
            </ui-select>
          </div>
          <div class="col-xs-2">
            <div class="btn-group">
              <button type="submit" class="btn btn-success">
                <i class="fa fa-search"></i>
              </button>
            </div>
          </div>
        </form>
      </div>
  
      <!-- Loader -->
      <p class="text-cinza preloader text-center" ng-show="ef.loading">
        <i class="fa fa-spinner fa-pulse fa-fw text-cinza"></i> Carregando...
      </p>
  
      <!-- List -->
      <p class="ibox-content padding" ng-if="!ef.loading && !ef.estadios.length">
        Nenhum item encontrado.
      </p>
      <div class="faq-item" ng-repeat="estadio in ef.estadios track by $index" data-index="{{$index}}">
        <div class="row">
          <div class="col-xs-6">
            <a class="faq-question">
              {{estadio.descricao}}
              <i ng-if="$root.permissions.estadios_fenologicos.canManage" ng-click="ef.openEdit(estadio.id)" class="fa fa-pencil"></i>
            </a>
            <small>
              <span class="font-bold text-center text-muted">{{estadio.abreviatura}}</span>&nbsp;&nbsp;
            </small>
          </div>
          <div class="col-xs-3 text-right">
            <span class="small font-bold">Atividade</span> <br>
            {{estadio.atividade.descricao | capitalize}}
          </div>
          <div class="col-xs-3 text-right">
            <button type="button" class="btn btn-danger" ng-if="$root.permissions.estadios_fenologicos.canManage"  ng-click="ef.deleteItem(estadio)" uib-tooltip="Apagar Estádio Fenológico" tooltip-placement="top">
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </div>
        <div class="row">
          <edit-estadio-fenologico estadio="estadio"
                           atividades="ef.atividades"
                           ng-if="estadio.edit"></edit-estadio-fenologico>
        </div>
      </div>
    </div>
  </page-data-manager>
  